import { type OnboardingTourStep, createOnboardingTourStep } from 'models';
import { useQuery } from 'query';
import { getOnboardingSteps } from '../services';
import { getOnboardingTourStepsQueryKey } from './keys';

export const useOnboardingTourSteps = (options?: { throwOnError?: boolean }) =>
  useQuery<OnboardingTourStep[]>({
    async queryFn() {
      const { data: steps } = await getOnboardingSteps();

      return steps.map((dataObject) => createOnboardingTourStep(dataObject));
    },
    queryKey: getOnboardingTourStepsQueryKey(),
    ...options,
  });
